// Token persistence. flutter_client uses flutter_secure_storage with keys
// access_token / refresh_token. On web inside Telegram we use localStorage;
// it is scoped to the Mini App origin. (CloudStorage could be added later for
// cross-device continuity, but it is async and not needed for MVP auth.)

const ACCESS_KEY = 'access_token';
const REFRESH_KEY = 'refresh_token';
const CLIENT_ID_KEY = 'client_id';

export const tokenStore = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  getClientId(): string | null {
    return localStorage.getItem(CLIENT_ID_KEY);
  },
  setTokens(access: string, refresh: string): void {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
  },
  setClientId(id: string): void {
    localStorage.setItem(CLIENT_ID_KEY, id);
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(CLIENT_ID_KEY);
  },
  isAuthenticated(): boolean {
    return !!localStorage.getItem(ACCESS_KEY) && !!localStorage.getItem(REFRESH_KEY);
  },
};
